import { Link } from "react-router-dom";

export default function PageFooter() {
    return (
        <footer
            style={{
                textAlign: "center",
                padding: 16,
                color: "var(--gt-text-muted)",
                fontSize: 12,
            }}
        >
            Planamoto · ©{new Date().getFullYear()} ·{" "}
            <Link to="/terms">Terms</Link> · <Link to="/privacy">Privacy</Link> ·{" "}
            <Link to="/faq">FAQ</Link> ·{" "}
            <Link to="/guides">Guides</Link>
        </footer>
    );
}
